var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-auth-root" },
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "el-steps",
            {
              staticClass: "step-box",
              attrs: {
                active: _vm.step,
                "finish-status": "success",
                space: "40%",
                "align-center": ""
              }
            },
            [
              _c("el-step", { attrs: { title: "完善信息" } }),
              _c("el-step", { attrs: { title: "认证完成" } })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 0,
                  expression: "step == 0"
                }
              ]
            },
            [
              _c(
                "el-form",
                {
                  ref: "AuthFormRfe",
                  attrs: {
                    model: _vm.AuthForm,
                    rules: _vm.rules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码", prop: "mobile" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.AuthForm.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.AuthForm, "mobile", $$v)
                          },
                          expression: "AuthForm.mobile"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "证件类型", prop: "identityImg" } },
                    [
                      _c("p", { staticStyle: { "text-align": "left" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "margin-right": "1vw"
                            }
                          },
                          [_vm._v("身份证")]
                        ),
                        _c("span", [
                          _vm._v("上传身份证照片，系统自动识别个人信息")
                        ])
                      ]),
                      _c("div", { staticClass: "card-box" }, [
                        _c(
                          "div",
                          { staticClass: "card-face" },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "#",
                                  "show-file-list": false,
                                  "on-success": function(
                                    response,
                                    file,
                                    fileList
                                  ) {
                                    return _vm.handleIdeCareSuccess(
                                      response,
                                      file,
                                      fileList,
                                      "personalFront"
                                    )
                                  },
                                  "before-upload": function(file) {
                                    return _vm.beforeIdeCareUpload(
                                      file,
                                      "personalFront"
                                    )
                                  }
                                }
                              },
                              [
                                _vm.personalFront.url
                                  ? _c("div", { staticClass: "preview-box" }, [
                                      _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.personalFront.url }
                                      }),
                                      _c("div", { staticClass: "img-box" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-delete-solid delete-sty",
                                          staticStyle: { color: "#fff" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.delBackImg("face")
                                            }
                                          }
                                        })
                                      ])
                                    ])
                                  : _c("div", [
                                      _c("div", { staticClass: "card-item" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                          staticStyle: {
                                            "font-size": "3vw",
                                            color: "#C2C2C2"
                                          }
                                        }),
                                        _c("p", { staticClass: "upload-tit" }, [
                                          _vm._v("人像面")
                                        ])
                                      ])
                                    ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "card-back" },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "#",
                                  "show-file-list": false,
                                  "on-success": function(
                                    response,
                                    file,
                                    fileList
                                  ) {
                                    return _vm.handleIdeCareSuccess(
                                      response,
                                      file,
                                      fileList,
                                      "personalVerso"
                                    )
                                  },
                                  "before-upload": function(file) {
                                    return _vm.beforeIdeCareUpload(
                                      file,
                                      "personalVerso"
                                    )
                                  }
                                }
                              },
                              [
                                _vm.personalVerso.url
                                  ? _c("div", { staticClass: "preview-box" }, [
                                      _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.personalVerso.url }
                                      }),
                                      _c("div", { staticClass: "img-box" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-delete-solid delete-sty",
                                          staticStyle: { color: "#fff" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.delBackImg("back")
                                            }
                                          }
                                        })
                                      ])
                                    ])
                                  : _c(
                                      "div",
                                      { staticClass: "card-item back" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                          staticStyle: {
                                            "font-size": "3vw",
                                            color: "#C2C2C2"
                                          }
                                        }),
                                        _c("p", { staticClass: "upload-tit" }, [
                                          _vm._v("国徽面")
                                        ])
                                      ]
                                    )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.AuthForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.AuthForm, "name", $$v)
                          },
                          expression: "AuthForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证号", prop: "identityNo" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.AuthForm.identityNo,
                          callback: function($$v) {
                            _vm.$set(_vm.AuthForm, "identityNo", $$v)
                          },
                          expression: "AuthForm.identityNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码", prop: "code" } },
                    [
                      _c(
                        "el-input",
                        {
                          model: {
                            value: _vm.AuthForm.code,
                            callback: function($$v) {
                              _vm.$set(_vm.AuthForm, "code", $$v)
                            },
                            expression: "AuthForm.code"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "append-btn-sty",
                              attrs: {
                                slot: "append",
                                disabled: _vm.codeText > 0
                              },
                              on: { click: _vm.getCode },
                              slot: "append"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.codeText > 0 ? _vm.codeText : "获取验证码"
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { checked: true },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#666666" } }, [
                        _vm._v("我已阅读并同意")
                      ]),
                      _c(
                        "a",
                        {
                          staticStyle: { color: "#409EFF" },
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              _vm.showProtocol = true
                            }
                          }
                        },
                        [_vm._v("《实名认证服务协议》")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn-sty",
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 1,
                  expression: "step == 1"
                }
              ],
              staticClass: "stpe-end"
            },
            [
              _c("div", { staticClass: "res-icon" }, [
                _c(
                  "div",
                  [
                    _c("img", {
                      attrs: { src: "/images/auth/authIcon/suc.png", alt: "" }
                    }),
                    _c("p", { staticClass: "text" }, [_vm._v("实名认证成功")]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.turnIndexPage }
                      },
                      [
                        _vm._v(
                          "返回首页" +
                            _vm._s(
                              _vm.turnTime > 0 ? "（" + _vm.turnTime + "）" : ""
                            )
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.codeVisi,
            width: "30%",
            "before-close": _vm.codeCloseBefore
          },
          on: {
            "update:visible": function($event) {
              _vm.codeVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "验证码：" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input-width",
                      attrs: {
                        "auto-complete": "off",
                        placeholder: "输入验证码"
                      },
                      model: {
                        value: _vm.imgCode,
                        callback: function($$v) {
                          _vm.imgCode = $$v
                        },
                        expression: "imgCode"
                      }
                    },
                    [
                      _c("template", { slot: "append" }, [
                        _c(
                          "span",
                          {
                            staticClass: "img-code",
                            on: { click: _vm.getImgCode }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "data:image/png;base64," + _vm.imgAuth.imgPath
                              }
                            })
                          ]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.codeCloseBefore } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.imgCodeConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("RealNameProtocol", {
        attrs: { visible: _vm.showProtocol, type: "register" },
        on: {
          "update:visible": function($event) {
            _vm.showProtocol = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b0bc9a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0bc9a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/personAuth.vue
// module id = A6D6
// module chunks = 170